import makeSprites from './makeSprites'
import Hexes from './Hexes'
import Nav from './Nav'
// import PieceGenerator from './PieceGenerator'
import Pieces from './Pieces'

export default {
  makeSprites,
  views: { Hexes, Nav, Pieces },
}
